import React from "react";
import PropTypes from "prop-types";
import { Form, Input } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";

export default function PaymentForm({
  form,
  vendorsList,
  purchaseAccounts,
  onCheckDateChange,
  onCheckNumberChange,
  onAmountChange,
  onVendorChange,
  onPurchaseAccountsChange,
  onMemoChange,
  onIsACHChange,
  onDontResetVendorChange
}) {
  const {
    checkDate,
    checkNumber,
    amount,
    vendorId,
    purchaseAccountCode,
    memo,
    isACH,
    dontResetVendor
  } = form;

  return (
    <Form>
      <Form.Group widths="equal">
        <DateInput
          label="Date*"
          dateFormat="MM/DD/YY"
          value={checkDate}
          onChange={onCheckDateChange}
        />

        <Form.Input
          label="Check Number*"
          disabled={isACH}
          type="number"
          value={checkNumber}
          onChange={onCheckNumberChange}
        />

        <Form.Field>
          <label>Amount*</label>
          <Input
            type="number"
            value={amount}
            onChange={onAmountChange}
          />
        </Form.Field>
      </Form.Group>

      <Form.Dropdown
        fluid
        search
        selection
        allowAdditions
        label="Vendor*"
        value={vendorId}
        options={vendorsList}
        onChange={onVendorChange}
      />

      <Form.Dropdown
        fluid
        search
        selection
        label="Purchase Account*"
        value={purchaseAccountCode}
        options={purchaseAccounts}
        onChange={onPurchaseAccountsChange}
      />

      <Form.Input
        label="Memo*"
        value={memo}
        onChange={onMemoChange}
      />

      <Form.Group inline>
        <Form.Checkbox
          label="Is bank transfer"
          checked={isACH}
          onChange={onIsACHChange}
        />
        <Form.Checkbox
          label="Don't Reset Vendor"
          checked={dontResetVendor}
          onChange={onDontResetVendorChange}
        />
      </Form.Group>
    </Form>
  );
}

PaymentForm.propTypes = {
  form: PropTypes.object.isRequired,
  vendorsList: PropTypes.array.isRequired,
  purchaseAccounts: PropTypes.array.isRequired,
  onCheckDateChange: PropTypes.func.isRequired,
  onCheckNumberChange: PropTypes.func.isRequired,
  onAmountChange: PropTypes.func.isRequired,
  onVendorChange: PropTypes.func.isRequired,
  onPurchaseAccountsChange: PropTypes.func.isRequired,
  onMemoChange: PropTypes.func.isRequired,
  onIsACHChange: PropTypes.func.isRequired,
  onDontResetVendorChange: PropTypes.func.isRequired
};
